export function toCommaSeperateList(array) {
    return array.map(item => item).join(', ');
}